import React from 'react';
import { IMAGES, type ImageId } from '../../assets/marketing/manifest';
import { focal } from '../content/images';
import { NAV_CTA } from '../content/nav';
import { HEALTH_CHECK_BAND } from '../content/home';
import { useHealthCheck } from '../health-check/HealthCheckProvider';
import Button from '../primitives/Button';
import Picture from '../primitives/Picture';
import Reveal from '../primitives/Reveal';

interface ClosingCtaProps {
  image: ImageId;
  title: string;
  body: string;
  /** Offer the Health Check alongside the waitlist. Off in hero mode, where the panel is not mounted. */
  withHealthCheck?: boolean;
  /** Replaces the waitlist call to action, e.g. "Discuss an assessment" as a mailto. */
  action?: { label: string; to?: string; href?: string };
}

/** A photograph beside a short statement and the two ways in. */
export default function ClosingCta({ image, title, body, withHealthCheck = true, action }: ClosingCtaProps) {
  const { open } = useHealthCheck();
  return (
    <section className="mk-section" aria-labelledby="closing-title">
      <div className="mk-container">
        <Reveal className="mk-closing">
          <Picture image={IMAGES[image]} alt="" sizes="(min-width: 900px) 50vw, 100vw" focal={focal(image)} />
          <div>
            <h2 id="closing-title" className="mk-closing__title t-headline">
              {title}
            </h2>
            <p className="mk-closing__body t-body">{body}</p>
            <div className="mk-closing__actions">
              {action?.href ? (
                <Button variant="fill" href={action.href}>
                  {action.label}
                </Button>
              ) : (
                <Button variant="fill" to={action?.to ?? NAV_CTA.to}>
                  {action?.label ?? NAV_CTA.label}
                </Button>
              )}
              {withHealthCheck && (
                <Button variant="link" onClick={open} aria-haspopup="dialog">
                  {HEALTH_CHECK_BAND.cta}
                </Button>
              )}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
